import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    success: false,
    message: ''
  });
  // Web3Forms API key
  const WEB3FORMS_API_KEY = "dd53e520-ce6e-47cc-a476-db8c5b0c449a"; // Provided API key
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({
      submitting: true,
      submitted: false,
      success: false,
      message: ''
    });
    try {
      // Create the form data for web3forms
      // Create payload for Web3Forms
      const payload = {
        access_key: WEB3FORMS_API_KEY,
        name: formData.name,
        email: formData.email,
        message: formData.message,
        subject: 'New Contact from Peerwatt Website',
        from_name: 'Peerwatt Website Contact Form',
        to_email: 'info@peerwatt.com'
      };
      // Send the email via web3forms API
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      const responseData = await response.json();
      
      if (response.status === 200 && responseData.success) {
        setStatus({
          submitting: false,
          submitted: true,
          success: true,
          message: 'Thank you! Your message has been sent successfully.'
        });
        
        // Clear form after successful submission
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      } else {
        throw new Error(responseData.message || 'Something went wrong');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus({
        submitting: false,
        submitted: true,
        success: false,
        message: 'Failed to send message. Please try again later.'
      });
    }
  };
  return (
    <section id="contact" style={{
      padding: '80px 5%',
      backgroundImage: 'linear-gradient(135deg, #f5f7fa 0%, #e4ecfb 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <h2 style={{
        fontSize: '2.5rem',
        textAlign: 'center',
        marginBottom: '50px',
        color: '#1a73e8'
      }}>Contact Us</h2>
      
      <form 
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '600px',
          width: '100%',
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        }}
        method="POST"
      >
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '8px',
            fontSize: '1rem',
            color: '#555'
          }}>
            Your Name
          </label>
          <input 
            type="text" 
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '1rem'
            }} 
          />
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '8px',
            fontSize: '1rem',
            color: '#555'
          }}>
            Email Address
          </label>
          <input 
            type="email" 
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            autoComplete="email"
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '1rem'
            }} 
          />
        </div>
        
        <div style={{ marginBottom: '30px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '8px',
            fontSize: '1rem',
            color: '#555'
          }}>
            Your Message
          </label>
          <textarea 
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '1rem',
              minHeight: '120px',
              resize: 'vertical'
            }}
          ></textarea>
        </div>
        
        {status.submitted && (
          <div style={{
            padding: '15px',
            marginBottom: '20px',
            borderRadius: '4px',
            backgroundColor: status.success ? '#e8f5e9' : '#ffebee',
            color: status.success ? '#2e7d32' : '#c62828'
          }}>
            {status.message}
          </div>
        )}
        
        <button 
          type="submit"
          disabled={status.submitting}
          style={{
            backgroundColor: status.submitting ? '#90caf9' : '#1a73e8',
            color: 'white',
            border: 'none',
            padding: '14px',
            borderRadius: '4px',
            fontSize: '1rem',
            cursor: status.submitting ? 'not-allowed' : 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 2px 10px rgba(26,115,232,0.3)',
            position: 'relative'
          }}
        >
          {status.submitting ? 'Sending...' : 'Send Message'}
        </button>
        
        
        {/* Instructions removed as we're now using a valid API key */}
      </form>
    </section>
  );
};

export default Contact;